import { render, staticRenderFns } from "./casino-home-custom-banner-2.vue?vue&type=template&id=2b0c6e1f"
import script from "./casino-home-custom-banner-2.vue?vue&type=script&lang=js"
export * from "./casino-home-custom-banner-2.vue?vue&type=script&lang=js"
import style0 from "./casino-home-custom-banner-2.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/casino-home-custom-banner-2.vue
// module id = p2CR
// module chunks = 0